import {
    form,
} from '@/utils/ajax'

const isNull = (v) => v === null

const localState = {
    icons: [],
    material: {
        name: {
            original: '',
            short: '',
        },
        shortName: '',
        icon: {
            path: '',
            id: '',
            name: '',
        },
        service_id: '',
        price: '',
    },
    defaultIcon: {
        id: '',
        path: '',
        name: '',
    },
    materials: null,
    modalType: 'add',
    activeMaterial: '',
    requestStatus: 2,
    page: 0,
    meta: {
        current_page: 1,
        last_page: 1,
    },

    deleteModal: false,
    deleteId: '',
    addModal: false,
    isEdit: false,
}

const mutations = {
    toggleModal: (state) => {
        state.addModal = !state.addModal
    },
    setMaterial: (state, v) => {
        state.material = v
        state.defaultIcon = v.icon
    },
    clearMaterial: (state) => {
        state.material = {
            name: {
                original: '',
                short: '',
            },
            shortName: '',
            icon: {
                path: '',
                id: '',
                name: '',
            },
            service_id: '',
            price: '',
        }
    },
    setMaterials: (state, {
        v,
        page,
    }) => {
        if (state.materials === null || page === 'materials') state.materials = v.data
        else {
            const { materials } = state
            state.materials = materials.concat(v.data)
        }

        state.meta = v.meta
    },
    clear: (state) => {
        state.page = 1
        state.deleteId = ''
        state.meta.current_page = 1
        state.meta.last_page = 1
    },
    incPage: (state) => {
        state.page = ++state.page
    },
    updateModalType: (state, v) => {
        state.modalType = v
    },
    setActiveMaterial: (state, v) => {
        state.activeMaterial = v
    },
    setIcons: (state, v) => {
        state.icons = v
    },
    setIcon: (state, v) => {
        state.defaultIcon = v
    },
    setRequestStatus: (state, v) => {
        state.requestStatus = v
    },

    toggleDeleteModal: (state) => {
        state.deleteModal = !state.deleteModal
    },
    setDeleteId: (state, v) => {
        state.deleteId = v
    },
}

const actions = {
    async fetch({
        commit,
        state,
    }, {
        id,
        orderBy = null,
        sortBy = null,
        limit = 20,
        page = null,
    }) {
        try {
            if (state.page >= state.meta.last_page && page !== 'materials') {
                return
            }

            if (state.page < state.meta.last_page) {
                commit('incPage')
            }

            let query = `?page=${state.page}&limit=${limit}`

            if (!isNull(orderBy)) query += `&orderBy=${orderBy}`
            if (!isNull(sortBy)) query += `&sortedBy=${sortBy}`

            const request = await this.$api.materials.fetch({
                id,
                query,
            })
            const response = await request.data

            commit('setMaterials', {
                v: response,
                page,
            })

            return response
        } catch (err) {
            console.log(err)
        }
    },
    async fetchMaterialIcons({
        commit,
    }) {
        try {
            const request = await this.$api.materials.fetchIcons()

            const response = await request.data.data
            commit('setIcons', response)
            commit('setIcon', response[0])
        } catch (err) {
            console.log(err)
        }
    },

    async add({
        dispatch,
        state,
    }, serviceId) {
        try {
            const data = {
                serviceId,
                originalName: state.material.name.original,
                shortName: state.material.name.short,
                iconId: state.material.icon,
                price: parseInt(state.material.price),
            }

            const fd = form(data)
            const send = await this.$api.materials.create(fd)

            await dispatch('fetch', {
                id: serviceId,
                page: 'materials',
            })
            return send
        } catch (e) {
            // log err
        }
    },

    async edit({
        dispatch,
        state,
    }, params) {
        const data = {
            serviceId: params.serviceId,
            originalName: state.material.name.original,
            shortName: state.material.name.short,
            iconId: state.material.icon,
            price: state.material.price,
            _method: 'PUT',
        }

        await this.$api.materials.update(params.materialId, data)

        await dispatch('fetch', {
            id: params.serviceId,
            page: 'materials',
        })
    },

    async del({
        state,
        commit,
        dispatch,
    }, params) {
        await this.$api.materials.remove(state.deleteId)
        await dispatch('fetch', {
            id: params.serviceId,
            page: 'materials',
        })
        commit('toggleDeleteModal')
    },

    async prepareEditModal({
        commit,
    }, id) {
        try {
            const request = await this.$api.materials.fetchById(id)
            const response = await request.data

            commit('setMaterial', response.data)
        } catch (err) {
            console.log(err)
        }
    },
}

const getters = {
    addNewModal: (state) => state.addNewModal,
    getMaterial: (state) => state.material,
    getMaterials: (state) => state.materials,
    getModalType: (state) => state.modalType,
    getActiveMaterial: (state) => state.activeMaterial,
    getMaterialIcons: (state) => state.icons,
    getDefaultIcon: (state) => state.defaultIcon,
    getRequestStatus: (state) => state.requestStatus,
    deleteModalGetters: (state) => state.deleteModal,
    addModalGetters: (state) => state.addModal,
    isEditGetters: (state) => state.isEdit,
    materialsDeleteId: (state) => state.deleteId,
}

export default {
    namespaced: true,
    state: localState,
    getters,
    actions,
    mutations,
}
